/**
 * VAVCI · Directorio de marcas: buscador en vivo + índice alfabético.
 *
 * Mejora progresiva: la rejilla se renderiza entera y todos los enlaces
 * funcionan sin JS. El buscador y el índice llegan con `hidden` puesto desde
 * Liquid y este módulo se lo quita al arrancar, así nadie ve controles muertos.
 *
 * La normalización (minúsculas, sin acentos ni apóstrofos) la hace LIQUID al
 * renderizar, en data-name/data-letter. Aquí solo se normaliza lo que teclea el
 * visitante, para que "gamma piu" encuentre "Gamma Più".
 *
 * Multi-instancia e idempotente: cada contenedor se inicializa una sola vez.
 */
function normalize(value) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['’.]/g, '')
    .replace(/[-&]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function initDirectory(root) {
  if (root.dataset.vbdInit === '1') return;
  root.dataset.vbdInit = '1';

  const cards = Array.from(root.querySelectorAll('[data-vbd-card]'));
  if (!cards.length) return;

  const input = root.querySelector('[data-vbd-search]');
  const letters = Array.from(root.querySelectorAll('[data-vbd-letter]'));
  const countNum = root.querySelector('[data-vbd-count-num]');
  const countWord = root.querySelector('[data-vbd-count-word]');
  const empty = root.querySelector('[data-vbd-empty]');
  const one = root.dataset.one || 'marca';
  const many = root.dataset.many || 'marcas';

  // A partir de aquí el filtrado funciona: se muestran los controles.
  root.querySelectorAll('[data-vbd-tools]').forEach((el) => el.removeAttribute('hidden'));

  // Affordance de scroll del índice: marca por qué borde sigue habiendo letras
  // para que el CSS funda ese lado. Se mide DESPUÉS de quitar `hidden` (oculto
  // mediría 0). El margen de 4px absorbe redondeos de subpíxel.
  const index = root.querySelector('.vbd__index');
  if (index) {
    const edges = () => {
      const max = index.scrollWidth - index.clientWidth;
      index.classList.toggle('has-left', index.scrollLeft > 4);
      index.classList.toggle('has-right', index.scrollLeft < max - 4);
    };
    index.addEventListener('scroll', edges, { passive: true });
    window.addEventListener('resize', edges);
    edges();
    // El swap de la fuente cambia las anchuras después del primer cálculo: sin
    // esto, en desktop quedaba un has-right huérfano fundiendo la última letra.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(edges);
  }

  let query = '';
  let letter = '';

  function apply() {
    let visible = 0;
    cards.forEach((card) => {
      const okQuery = query === '' || card.dataset.name.indexOf(query) !== -1;
      const okLetter = letter === '' || card.dataset.letter === letter;
      const show = okQuery && okLetter;
      card.toggleAttribute('hidden', !show);
      if (show) visible += 1;
    });

    // textContent, no innerHTML: el singular/plural es texto de un ajuste y no
    // tiene por qué acabar interpretándose como marcado.
    if (countNum) countNum.textContent = String(visible);
    if (countWord) countWord.textContent = visible === 1 ? one : many;
    if (empty) empty.toggleAttribute('hidden', visible > 0);
  }

  if (input) {
    input.addEventListener('input', () => {
      query = normalize(input.value);
      apply();
    });
  }

  letters.forEach((button) => {
    button.addEventListener('click', () => {
      letter = button.dataset.vbdLetter;
      letters.forEach((other) => {
        const active = other === button;
        other.classList.toggle('is-active', active);
        other.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      apply();
    });
  });

  apply();
}

function boot() {
  document.querySelectorAll('[data-vbd]').forEach(initDirectory);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}

// Editor de temas: re-inicializa al recargar/añadir la sección.
document.addEventListener('shopify:section:load', boot);
